import Swiper from 'swiper';

var galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 7,
  loop: false,
  freeMode: true,
  // loopedSlides: 2, //looped slides should be the same
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 10,
  autoHeight: true, //enable auto height
  loop: true,
  loopedSlides: 7, //looped slides should be the same
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: galleryThumbs,
  },
  on: {
    slideChangeTransitionEnd: function(swiper) {
      var currentIndexEl = document.querySelector('.title-index .gallery-current');
      console.log(currentIndexEl);
      if (currentIndexEl) {
        currentIndexEl.textContent = this.realIndex + 1;
      }
    }
  }
});